module.exports = __webpack_public_path__ + "img/empty-state.2e45c512.png";